import { Box, Image, Flex, Spacer } from '@chakra-ui/react';
import { CustomButton } from '../UI/CustomButton';
import { MdDashboard, MdCheckCircle, MdEdit, MdSelfImprovement, MdInterests, MdFormatListBulleted, MdLogout } from 'react-icons/md';
import { useLocation, useNavigate } from 'react-router-dom';
import { useToastContext } from '../UI/ToastManager';
import { ReactComponent as WorkoutInfoIcon } from '../../assets/icons/workout-info.svg'

const navItems = [
  { icon: MdDashboard, label: 'Dashboard', path: '/dashboard' },
  { icon: MdCheckCircle, label: 'Competitions', path: '/competitions' },
  { icon: MdSelfImprovement, label: 'Exercises', path: '/exercises' },
  { icon: MdInterests, label: 'Programs', path: '/programs' },
  { icon: MdFormatListBulleted, label: 'Program Constrained', path: '/program-constrained' },
  { icon: WorkoutInfoIcon, label: 'Workout Info', path: '/workouts-info' },
];

export function Sidebar({ onLogout }: { onLogout: () => void }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { showInfo } = useToastContext();

  const navigateTo = (path: string) => {
    if (location.pathname !== path) {
      navigate(path);
    }
  };

  const handleLogout = () => {
    showInfo('Logout Successful', 'You have been successfully logged out.');
    onLogout();
  };

  return (
    <Box as="nav" bg="#fafafa" w="284px" minH="100vh" p="16px" display="flex" flexDirection="column">
      <Image src="/logo.png" alt="QONA" boxSize="90px" mb="24px" />
      <Flex direction="column" gap={2} fontWeight="medium">
        {navItems.map(({ icon: Icon, label, path }) => (
          <CustomButton
            key={path}
            onClick={() => navigateTo(path)}
            visual="ghost"
            justifyContent="flex-start"
            fontSize="16px"
            className={location.pathname === path ? 'selected' : ''}
          >
            <Icon style={{ marginRight: '28px', fontWeight: '400', color: location.pathname === path ? '#ff002d' : '#8B8B8B' }} />
            {label}
          </CustomButton>
        ))}
      </Flex>
      <Spacer />
      <CustomButton
        justifyContent="flex-start"
        mt={4}
        visual="ghost"
        onClick={handleLogout}
        colorScheme="gray"
        fontSize="16px"
      >
        <MdLogout style={{ marginRight: '28px', fontWeight: '400' }} /> Log Out
      </CustomButton>
    </Box>
  );
}